/**
 * Load beautiful circular sprites for network activity particles
 */

let spriteTexture: any = null;
let spriteTexturePromise: Promise<any> | null = null;

export function loadSpriteTexture(THREE: any): Promise<any> {
  if (spriteTexture) {
    return Promise.resolve(spriteTexture);
  }
  
  if (spriteTexturePromise) {
    return spriteTexturePromise;
  }
  
  const { TextureLoader } = THREE as any;
  const loader = new TextureLoader();
  
  spriteTexturePromise = loader.loadAsync('/sprites/soul_sprite.png')
    .then((texture: any) => {
      spriteTexture = texture;
      return texture;
    })
    .catch((error: any) => {
      console.warn('[SpriteLoader] Failed to load soul_sprite.png, using default sprite', error);
      // Return null to use default sprite
      return null;
    });
  
  return spriteTexturePromise;
}


